/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetGooseGameStoreItemsQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Float"];
}>;

export type GetGooseGameStoreItemsQuery = {
  gooseGameStoreItems: Array<
    Pick<
      Types.GooseGameItem,
      | "id"
      | "name"
      | "description"
      | "point_cost"
      | "quantity_available"
      | "user_redemption_limit"
      | "is_sold_out"
    >
  >;
};

export const GetGooseGameStoreItemsDocument = gql`
  query GetGooseGameStoreItems($event_id: Float!) {
    gooseGameStoreItems(event_id: $event_id) {
      id
      name
      description
      point_cost
      quantity_available
      user_redemption_limit
      is_sold_out
    }
  }
`;

/**
 * __useGetGooseGameStoreItemsQuery__
 *
 * To run a query within a React component, call `useGetGooseGameStoreItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGooseGameStoreItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGooseGameStoreItemsQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetGooseGameStoreItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGooseGameStoreItemsQuery,
    GetGooseGameStoreItemsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetGooseGameStoreItemsQuery,
    GetGooseGameStoreItemsQueryVariables
  >(GetGooseGameStoreItemsDocument, baseOptions);
}
export function useGetGooseGameStoreItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGooseGameStoreItemsQuery,
    GetGooseGameStoreItemsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetGooseGameStoreItemsQuery,
    GetGooseGameStoreItemsQueryVariables
  >(GetGooseGameStoreItemsDocument, baseOptions);
}
export type GetGooseGameStoreItemsQueryHookResult = ReturnType<
  typeof useGetGooseGameStoreItemsQuery
>;
export type GetGooseGameStoreItemsLazyQueryHookResult = ReturnType<
  typeof useGetGooseGameStoreItemsLazyQuery
>;
export type GetGooseGameStoreItemsQueryResult = ApolloReactCommon.QueryResult<
  GetGooseGameStoreItemsQuery,
  GetGooseGameStoreItemsQueryVariables
>;
